<template>
  <fbk-page>
    <b-card>
      <b-row>
        <b-col>
          <h5 class="my-4">Yfirlit yfir vinnustaði</h5>
        </b-col>
        <b-col>
          <div class="my-4 pull-right" v-if="loggedInUser.can_edit === 1">
            <b-link class="btn btn-secondary" href @click.prevent="workplaceCreateModal"
              ><i class="fa fa-fw fa-plus-circle"></i> Skrá vinnustað</b-link
            >
          </div>
        </b-col>
      </b-row>
      <!--div class="text-center" v-if="loading.workplace">
        <i class="fa fa-fw fa-spin fa-spinner"></i> Augnablik...
      </div-->
      <table class="table">
        <tr>
          <th style="padding: 10px 10px 10px 0px; width: 50%">
            <b-form-input id="name" name="name" type="text" v-model="searchName" placeholder="Leita eftir heiti eða kennitölu">
            </b-form-input>
          </th>
          <th style="padding: 10px 0px 10px 0px; width: 50%">
            <b-form-select id="profession" name="profession" v-model="searchProfession">
              <option :value="null">-- Veldu starfsgrein --</option>
              <option v-for="(profession, index) in professionList" :key="index" :value="profession">{{ profession.name }}</option>
            </b-form-select>
          </th>
        </tr>
      </table>

      <div class="mb-3" v-if="canToggleActive">
        <b-form-checkbox v-model="showDisabled" switch>
          Sýna óvirka vinnustaði
        </b-form-checkbox>
      </div>

      <div>
        <table class="table table-hover">
          <tr>
            <th>Heiti</th>
            <th>Kennitala</th>
            <th>Símanúmer</th>
            <th>Fjöldi plássa</th>
            <th>Starfsgreinar</th>
            <th v-if="canToggleActive">Staða</th>
            <th v-if="canToggleActive"></th>
          </tr>
          <tbody>
            <tr v-if="!loading.workplace && workplaceList.length == 0">
              <td :colspan="canToggleActive ? 7 : 5">
                <i>Engar leitarniðurstöður fundust.</i>
              </td>
            </tr>
            <tr v-if="loading.workplace">
              <td :colspan="canToggleActive ? 7 : 5">
                <i class="fa fa-fw fa-spin fa-spinner text-center"></i>
              </td>
            </tr>
            <tr v-for="workplace in workplaceList" :key="workplace.id">
              <!--td style="width: 40px;" class="pr-0 pt-3">
                <avatar :name="workplace.name" :color="0" class="d-inline-block mr-2"></avatar>
              </td-->
              <td>
                {{ workplace.name }}
                <b-link
                  class="text-secondary"
                  @click.prevent="workplaceUpdateModal(workplace.id)"
                  v-if="canEdit(workplace)"
                  v-b-tooltip.hover
                  title="Breyta vinnustað"
                >
                  <i class="fa fa-fw fa-pencil hover-edit"></i>
                </b-link>
              </td>
              <td>
                {{ workplace.ssn | subStr }}
              </td>
              <td>
                {{ workplace.phonenumber }}
              </td>
              <td>
                {{ workplace.slots }}
              </td>
              <td>
                <span v-for="(profession, index) in workplace.professions" :key="profession.id">
                  <span v-if="index != 0">, </span>{{ profession.name }}({{ profession.slots }})
                </span>
              </td>
              <td v-if="canToggleActive">
                <b-badge :variant="workplace.is_deleted === 1 ? 'danger' : 'success'">
                  {{ workplace.is_deleted === 1 ? 'Óvirkur' : 'Virkur' }}
                </b-badge>
              </td>
              <td v-if="canToggleActive">
                <b-link
                  v-if="workplace.is_deleted === 1"
                  class="text-success"
                  @click.prevent="toggleActive(workplace, true)"
                  v-b-tooltip.hover
                  title="Endurvirkja vinnustað"
                >
                  <i class="fa fa-fw fa-check-circle"></i> Virkja
                </b-link>
                <b-link
                  v-else
                  class="text-danger"
                  @click.prevent="toggleActive(workplace, false)"
                  v-b-tooltip.hover
                  title="Afvirkja vinnustað"
                >
                  <i class="fa fa-fw fa-ban"></i> Afvirkja
                </b-link>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-if="pagination" :pagination-response="pagination" @change-limit="changeLimit" @change-page="changePage"></pagination>
      </div>
    </b-card>
    <!-- Modal til að skrá vinnustað -->
    <workplace-crud-modal ref="workplaceCreateModal" @successful="workplaceUpdated"></workplace-crud-modal>
    <!-- Modal til að uppfæra vinnustað -->
    <workplace-crud-modal ref="workplaceUpdateModal" @successful="workplaceUpdated"></workplace-crud-modal>
  </fbk-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import core from '@/api/core';
import Pagination from '@/components/Pagination.vue';
import WorkplaceCrudModal from '@/components/workplace/WorkplaceCrudModal.vue';

import { debounce, paginationMixin, parsePagination } from '@/utils';

export default {
  name: 'workplace-list',
  paginationStorageKey: 'workplaces',
  mixins: [paginationMixin],
  components: {
    Pagination,
    WorkplaceCrudModal,
  },
  data() {
    return {
      loading: {
        workplace: false,
        profession: false,
      },
      page: null,
      pagination: null,
      workplaceList: [],
      professionList: [],
      searchProfession: null,
      searchName: '',
      showDisabled: false,
    };
  },
  filters: {
    subStr(string) {
      const newString = `${string.substring(0, 6)}-${string.substring(6, 10)}`;
      return newString;
    },
  },
  computed: {
    ...mapState({
      loggedInUser: 'loggedInUser',
    }),
    // Aðeins master admin eða (admin OG símenntun) mega virkja/afvirkja vinnustaði.
    // (is_mms eitt og sér nær yfir ~95% notenda svo það dugar ekki sem takmörkun.)
    canToggleActive() {
      return (
        this.loggedInUser.is_master_admin === 1 ||
        (this.loggedInUser.is_admin === 1 && this.loggedInUser.is_mms === 1)
      );
    },
  },
  methods: {
    /*
     * Sækja yfirlit yfir vinnustaði
     */
    async loadList(page = null, limit = this.limit) {
      this.loading.workplace = true;
      this.pagination = null;
      this.workplaceList = [];
      try {
        const response = await core.workplaceList(page, limit, this.searchProfession, this.searchName, this.showDisabled);
        this.workplaceList = response.data.items;
        this.pagination = parsePagination(response.data.extra, response.data.items);
      } catch (e) {
        this.$log.error(e);
        this.displayError(
          `Óvænt villa (${e.response ? e.response.status : -1}) kom upp við að sækja yfirlit yfir vinnustaði. Vinsamlegast reyndu aftur.`,
        );
      } finally {
        this.loading.workplace = false;
      }
    },
    async loadProfession() {
      this.loading.profession = true;
      try {
        const response = await core.professionList({});
        this.professionList = response.data;
      } catch (e) {
        this.$log.error(e);
        this.displayError(
          `Óvænt villa (${
            e.response ? e.response.status : -1
          }) kom upp við að sækja yfirlit yfir starfsgreinar. Vinsamlegast reyndu aftur.`,
        );
      } finally {
        this.loading.profession = false;
      }
    },
    canEdit(workplace) {
      return workplace.professions.filter((x) => x.can_edit === 1).length > 0;
    },
    /*
     * Aðgerðir á modal gluggum.
     */
    workplaceCreateModal() {
      this.$refs.workplaceCreateModal.show();
    },
    workplaceUpdateModal(id) {
      this.$refs.workplaceUpdateModal.show(id);
    },
    workplaceUpdated() {
      this.loadList();
    },
    /*
     * Virkja/afvirkja vinnustað.
     */
    async toggleActive(workplace, isActive) {
      try {
        await core.workplaceSetActive(workplace.id, isActive);
        this.displaySuccess(isActive ? 'Vinnustaður virkjaður.' : 'Vinnustaður afvirkjaður.');
        // Halda notandanum á sömu blaðsíðu eftir breytingu.
        this.loadList(
          this.pagination ? this.pagination.currentPage : null,
          this.pagination ? this.pagination.currentLimit : null,
        );
      } catch (e) {
        this.$log.error(e);
        this.displayError(
          `Óvænt villa (${e.response ? e.response.status : -1}) kom upp við að breyta stöðu vinnustaðar. Vinsamlegast reyndu aftur.`,
        );
      }
    },
    /**
     * Annað
     */
    ...mapActions(['displayError', 'displaySuccess']),
  },
  watch: {
    searchName: debounce(function () {
      this.loadList(null);
    }, 500),
    searchProfession: debounce(function () {
      this.loadList(null);
    }, 500),
    showDisabled() {
      this.loadList(null);
    },
  },
  created() {
    this.loadList();
    this.loadProfession();
  },
};
</script>
<style lang="scss" scoped>
tr:nth-child(even) {
  background: #f1f1f1;
}
tr:nth-child(odd) {
  background: #fff;
}
</style>
